
import Vue from "vue"
import { getLs, setLs, storageKeys } from "@/utils/storage"

export default Vue.extend({
  data: () => ({
    isVisible: false,
  }),

  mounted () {
    const isAccepted = getLs(storageKeys.cookieAccept)
    if (!isAccepted)
      this.isVisible = true
  },

  methods: {
    accept () {
      this.isVisible = false
      setLs(storageKeys.cookieAccept, true)
    },
  },
})
